import { render } from "./JzLabel.vue?vue&type=template&id=ea738e94&scoped=true"
import script from "./JzLabel.vue?vue&type=script&lang=js"
export * from "./JzLabel.vue?vue&type=script&lang=js"

import "./JzLabel.vue?vue&type=style&index=0&id=ea738e94&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea738e94"]])

export default __exports__